export default {"src":"https://assets.eu.daedalus.fih.io/_next/static/media/at.54d39a51.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};